export default {
  regions: (state) => Object.keys(state.groups),
  locations: (state) => JSON.parse(JSON.stringify(state.locations))
}
